module.exports = __webpack_public_path__ + "static/media/salcedonie.background.65e1276f.png";